import { useState, useEffect, useMemo } from 'react';
import Grid from '@material-ui/core/Grid';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import AppBar from '@material-ui/core/AppBar';
import DeleteIcon from '@material-ui/icons/Delete';
import IconButton from '@material-ui/core/IconButton';
import Tooltip from '@material-ui/core/Tooltip';
import TabPanel from './TabPanel';
import { handleSnackBar } from '../../store/global/actions';
import { marginBottomForBreadCrumb } from '../../config/styles';
import { useDispatch, useSelector } from 'react-redux';
import BreadCrumb from '../atoms/breadcrumb/';
import SectionTree from '../molecules/sections/SectionTree';
import CreateSection from '../molecules/sections/CreateSection'
import Divider from '@material-ui/core/Divider';
import CreateField from '../molecules/fields/CreateField'
import DeleteSectionAlert from '../molecules/alerts/DeleteSectionAlert';
import EditSection from '../molecules/sections/EditSection';
import EditField from '../molecules/fields/EditField';
import EditProfile from '../molecules/profiles/EditProfile';
import DeleteFieldAlert from '../molecules/alerts/DeleteFieldAlert';
import EditAnalytics from '../molecules/analytics/EditAnalytics';
import DeleteAnalyticsAlert from '../molecules/alerts/DeleteAnalyticsAlert'
import ListTransactions from '../molecules/transactions/ListTransactions';
import { setFocusElement, toggleRightDrawer, reRenderInfoBuilder, setReRender, setTabOnFocus } from '../../store/global/actions'
import AllEvents from '../molecules/events/AllEvents';
import ClusterletDashboard from '../atoms/dialog/ClusterletDashboard';
import { getElementOnFocus, getTabOnFocus } from '../../store/global/selectors';
import DeleteProfileAlert from '../molecules/alerts/DeleteProfileAlert';
import { invokeGetService } from '../../store/global/actions';
import ErrorPresenter from "../atoms/errors/ErrorPresenter";
import { useBottomDrawer } from '../../hooks/useBottomDrawer';
import { Box } from '@material-ui/core';

export default function Analytics({ element, transactionScreen, bottomDrawer }) {

    const dispatch = useDispatch();
    const defaultAction = { action: `create_anlaytics`, id: null, item: null };
    const [action, setAction] = useState(defaultAction);
    const [vErrors, setVErrors] = useState([]);
    const [showDeleteAlert, setShowDeleteAlert] = useState(true);
    const elementOnFocus = useSelector(getElementOnFocus);
    const [dashboardPreviewDialog, setDashboardPreviewDialog] = useState(false);
    const dashboardPreviewItems = ['clusterlet', 'analytics'];
    const tabOnFocus = useSelector(getTabOnFocus);
    const [itemToExpand, setItemToExpand] = useState(null);
    const [showDeleteProfileAlert, setShowDeleteProfileAlert] = useState(false);
    const [profileExists, setProfleExists] = useState(true);
    const [value, setValue] = useState(0)
    const [refreshTree, setRefreshTree] = useState(0);

    const bottomDrawerConfig = useBottomDrawer()
    const {activeTab, setActiveTab, setTabConfig} = bottomDrawerConfig || {}

    useEffect(() => {
        if(bottomDrawer){
            setActiveTab(tabOnFocus)
        }else{
            setValue(tabOnFocus);
        }
        setAction({})
    }, [tabOnFocus])

    const detailsBC = [
        { label: process.env.REACT_APP_ANALYTICS, url: null },
        { label: element.name, url: null }
    ];

    const onCompletion = (type, action, errors, name, item) => {
        // console.log("onCompletion-------------------------->", {type, action, errors, name, item})
        if (action != undefined) {

            switch (action) {
                case 'add':
                    dispatch(handleSnackBar({ open: true, message: `${type} created`, severity: "success" }));
                    if (type === "Section") {
                        setItemToExpand(item?._id.toString());
                        setAction({ action: 'edit_section', id: item?._id.toString(), item: item });
                        setProfleExists(true)
                    } else if (type === "Field") {
                        setItemToExpand(item?._id.toString());
                        setAction({ action: 'edit_field', id: item?._id.toString(), item: item });
                    }
                    else {
                        setAction({});
                    }
                    dispatch(setReRender());
                    break;

                case 'edit':
                    dispatch(handleSnackBar({ open: true, message: `${type} updated`, severity: "success" }));
                    dispatch(reRenderInfoBuilder());
                    if (type !== 'Field' && type !== 'Section') {
                        if (process.env.REACT_APP_AUTO_CLOSE == 'true') {
                            dispatch(toggleRightDrawer());
                        }
                    }

                    if (type === "Section") {
                        setItemToExpand(item?._id.toString());
                        setAction({ action: 'edit_section', id: item?._id.toString(), item: item })
                    } else if (type === "Field") {
                        setItemToExpand(item?._id.toString());
                        setAction({ action: 'edit_field', id: item?._id.toString(), item: item })
                    } else {
                        setAction({});
                    }
                    dispatch(setReRender());
                    break;

                case 'delete':
                    dispatch(handleSnackBar({ open: true, message: `${type} deleted`, severity: "success" }));
                    if (type !== 'Field' && type !== 'Section') {
                        dispatch(setReRender());
                        dispatch(setFocusElement({}));
                        dispatch(toggleRightDrawer());
                    }
                    setAction({})
                    dispatch(setReRender());
                    break;


                case 'clone':
                    dispatch(handleSnackBar({ open: true, message: `${type} cloned`, severity: "success" }));
                    setAction({})
                    break;
                default: 
                    break;

            }
            dispatch(reRenderInfoBuilder());
            setRefreshTree(c => c + 1);

        }
        if (errors !== undefined && action == 'edit') {
            setVErrors(errors);
        }
    }

    const onClose = () => {
        setAction({})
    }

    const dashboardPreview = () => {

        setDashboardPreviewDialog(true)

    }

    const handlerClickDeleteButton = () => {
        setAction({ action: 'delete_analytics' });
        setShowDeleteAlert(true);
    }

    const handleClickDeleteProfileButton = () => {
        setAction({ action: 'delete_dt_profile' });
        setShowDeleteProfileAlert(true)
    }

    // useEffect(() => {
    //     dispatch(triggerTour({ currentTour: 'clusterletDrawer' }))
    // }, [])

    useEffect(() => {
        if(element?.openSectionForm){
            setAction({action: 'create_section'})
        }
        dispatch(invokeGetService('getClusterlet', [element.id])).then(res => {
            if (res?.status == true) {
                if(res?.data != undefined && res?.data?.profile != undefined && Array.isArray(res?.data?.profile) && res?.data?.profile.length == 0) {
                    setProfleExists(false)
                }
                else{
                    setProfleExists(true)
                }
            }
        })
    },[element])

    useMemo(() => {
        if(bottomDrawer){
            setTabConfig([
                {
                    label: process.env.REACT_APP_ANALYTICS,
                    tourId: "clusterlet-tab"
                },
                {
                    label: "Properties",
                    tourId: "clusterlet-properties-tab"
                },
                {
                    label: "Profile",
                    tourId: "clusterlet-profile-tab"
                },
                {
                    label: "Events",
                    tourId: "clusterlet-events-tab"
                },
                {
                    label: "Transactions",
                    tourId: "clusterlet-transactions-tab"
                }
    
            ])
        }
    },[])

    return (
        <>
            {
                !bottomDrawer &&
                <AppBar position="static">
                    <Tabs value={bottomDrawer ? activeTab : value} onChange={(e, v) => { setValue(v); dispatch(setTabOnFocus(v)); }} aria-label="simple tabs example">
                        <Tab label={process.env.REACT_APP_ANALYTICS} data-ui-tour-id='clusterlet-tab' />
                        <Tab label="Properties" data-ui-tour-id='clusterlet-properties-tab' />
                        <Tab label="Profile" data-ui-tour-id='clusterlet-profile-tab' />
                        <Tab label="Events" data-ui-tour-id='clusterlet-events-tab' />
                        <Tab label="Transactions" data-ui-tour-id='clusterlet-transactions-tab' />
                    </Tabs>
                </AppBar>
            }

            <TabPanel value={bottomDrawer ? activeTab : value} index={0} >
                {
                    bottomDrawer ? 
                    <Box style={{height: '5px'}} />
                    :
                    <>
                        <Grid container direction={"row"} spacing={2}>
                            {
                                !bottomDrawer &&
                                <Grid item xs={8}>
                                    <BreadCrumb items={detailsBC} />
                                </Grid>

                            }
                            {!transactionScreen &&
                            <Grid item xs={4} style={{ display: "flex", justifyContent: "flex-end" }}>
                                <Tooltip title={`Delete ${process.env.REACT_APP_ANALYTICS}`} arrow>
                                    <IconButton onClick={e => handlerClickDeleteButton()}><DeleteIcon color="secondary" /></IconButton>
                                </Tooltip>
                            </Grid>}
                            
                        </Grid>
                        <Divider style={marginBottomForBreadCrumb} />
                    </>
                }
                
                <EditAnalytics element={element} onCompletion={onCompletion} onClose={() => setAction({})} />
                {action.action == 'delete_analytics' && showDeleteAlert &&
                    <DeleteAnalyticsAlert onCompletion={onCompletion} setShowDeleteAlert={setShowDeleteAlert} element={element} onClose={() => setAction({})} />
                }
            </TabPanel>

            <TabPanel value={bottomDrawer ? activeTab : value} index={1}>
                
                {
                    bottomDrawer ?
                    <Box style={{height: '5px'}} />
                    :
                    <>
                        <Grid container direction={"row"} spacing={2}>
                            <Grid item xs={8}>
                                <BreadCrumb items={[...detailsBC, { label: 'Properties', url: null }]} />
                            </Grid>
                        </Grid>
                        <Divider style={marginBottomForBreadCrumb} />
                    </>
                }
                <Grid container direction={"row"} spacing={2} className='verticalScrollBar'>

                    <Grid item xs={6} style={{ height: "73vh" }}>
                        <SectionTree action={action} parent={element} setAction={setAction} itemToExpand={itemToExpand} refreshTree={refreshTree} setRefreshTree={setRefreshTree}/>
                    </Grid>

                    {action.action == 'create_section' && <Grid item xs={6} className='stickyContainer'>
                        <CreateSection onClose={onClose} onCompletion={onCompletion} />
                    </Grid>}

                    {action.action == 'edit_section' && <Grid item xs={6} className='stickyContainer'>
                        <EditSection isProfile={false} key={action.id} item={action.item} sectionID={action.id} onClose={() => setAction({})} onCompletion={onCompletion} />
                    </Grid>}

                    {action.action == 'create_field' && <Grid item xs={6} className='stickyContainer'>
                        <CreateField onClose={() => setAction({})} onCompletion={onCompletion} section={action} parentDT={true} />
                    </Grid>}

                    {action.action == 'edit_field' && <Grid item xs={6} className='stickyContainer'>
                        <EditField key={action.id} onClose={() => setAction({})} onCompletion={onCompletion} fields={action} parentDT={true} />
                    </Grid>}

                </Grid>

                {action.action == 'delete_section' &&
                    <DeleteSectionAlert onCompletion={onCompletion} id={action.id} onClose={() => setAction({})} />
                }

                {action.action == 'delete_field' &&
                    <DeleteFieldAlert element={action.element} onCompletion={onCompletion} id={action.id} onClose={() => setAction({})} />
                }

                {dashboardPreviewDialog && <ClusterletDashboard clusterlet={elementOnFocus} ClusterletDashboardDialog={setDashboardPreviewDialog} />}

            </TabPanel>


            <TabPanel value={bottomDrawer ? activeTab : value} index={2}>
                
                {
                    bottomDrawer &&
                    <Box style={{height: '5px'}} />
                }
                <Grid container direction={"row"} spacing={2}>
                    {
                        !bottomDrawer &&
                        <Grid item xs={8}>
                            <BreadCrumb items={[...detailsBC, { label: 'Profile', url: null }]} />
                        </Grid>
                    }

                    <Grid item xs={bottomDrawer ? 12 : 4} style={{ display: "flex", justifyContent: "flex-end" }}>
                        <Tooltip title="Delete Profile" arrow>
                            <IconButton onClick={() => handleClickDeleteProfileButton()} disabled={profileExists? false : true}><DeleteIcon color="secondary" /></IconButton>
                        </Tooltip>
                    </Grid>

                    {/* <Grid item xs={4} style={{ display: "flex", justifyContent: "flex-end" }}>
                        <Tooltip title="Add Property">
                            <Button startIcon={<AddCircleOutlinedIcon />} onClick={e => setAction({ action: 'create_section' })} color="primary" variant="contained" style={{ marginLeft: 10, marginBottom: 10 }} >
                                Add Property
                            </Button>
                        </Tooltip>
                    </Grid> */}
                </Grid>

                {
                    !bottomDrawer &&
                    <Divider style={marginBottomForBreadCrumb} />
                }

                <Grid container direction={"row"} spacing={2} className='verticalScrollBar'>

                    <Grid item xs={6} style={{ height: "73vh" }}>
                        <SectionTree action={action} parent={{ name: `${element.name}_Profile`, id: element?.id }} setAction={setAction} profile={true} refreshTree={refreshTree} setRefreshTree={setRefreshTree}/>
                    </Grid>

                    {action.action == 'create_section' && <Grid item xs={6} className='stickyContainer'>
                        <CreateSection onClose={onClose} onCompletion={onCompletion} profile={true} />
                    </Grid>}

                    {action.action == 'edit_section' && <Grid item xs={6} className='stickyContainer'>
                        <EditSection isProfile={true} sectionID={action.id} item={action.item} onClose={() => setAction({})} onCompletion={onCompletion} profile={true} />
                    </Grid>}

                    {action.action == 'create_field' && <Grid item xs={6} className='stickyContainer'>
                        <CreateField onClose={() => setAction({})} onCompletion={onCompletion} section={action} parentDT={false} />
                    </Grid>}

                    {action.action == 'edit_field' && <Grid item xs={6} className='stickyContainer'>
                        <EditField key={action.id} onClose={() => setAction({})} onCompletion={onCompletion} fields={action} parentDT={false} />
                    </Grid>}

                    {action.action == 'edit_profile' && <Grid item xs={6} className='stickyContainer'>
                        <EditProfile key={action.id} profileId={action?.item?.id} onClose={() => setAction({})} onCompletion={onCompletion} />
                    </Grid>}

                    {action.action == 'delete_dt_profile' && showDeleteProfileAlert && 
                        <DeleteProfileAlert id={element?.id} onCompletion={onCompletion}  onClose={() => {setAction({}); setShowDeleteProfileAlert(false)}}/>
                    }
                </Grid>


                {action.action == 'delete_section' &&
                    <DeleteSectionAlert onCompletion={onCompletion} id={action.id} onClose={() => setAction({})} />
                }

                {action.action == 'delete_field' &&
                    <DeleteFieldAlert element={action.element} onCompletion={onCompletion} id={action.id} onClose={() => setAction({})} />
                }
            </TabPanel>

            <TabPanel value={bottomDrawer ? activeTab : value} index={3}>
                {
                    bottomDrawer ? 
                    <Box style={{height: '5px'}} />
                    :
                    <>
                        <BreadCrumb items={[...detailsBC, { label: 'Events', url: null }]} />
                        <Divider style={marginBottomForBreadCrumb} />
                    </>
                }
                <AllEvents element={element} />
            </TabPanel>

            <TabPanel value={bottomDrawer ? activeTab : value} index={4}>
                {
                    bottomDrawer ?
                    <Box style={{height: '5px'}} />
                    :
                    <>
                        <BreadCrumb items={[...detailsBC, { label: 'Transactions', url: null }]} />
                        <Divider style={marginBottomForBreadCrumb} />
                    </>
                }
                <ListTransactions element={element} />
            </TabPanel>

            {vErrors.length > 0 && <ErrorPresenter errors={vErrors} />}

        </>
    )

}